import {
  makeListState,
  makePaginationState,
  convertListToPagination,
  STATUSES,
} from 'app/utils/redux';

import * as t from './types';

const initialState = {
  searchTags: makeListState(),
  popularTags: makePaginationState(),
  categories: makeListState(),
};

export default (state = initialState, action) => {
  switch (action.type) {
    case `${t.FETCH_SEARCH_TAGS}_PENDING`:
      return {
        ...state,
        searchTags: {
          ...state.searchTags,
          status: STATUSES.PENDING,
        },
      };
    case `${t.FETCH_SEARCH_TAGS}_SUCCESS`:
      return {
        ...state,
        searchTags: {
          ...state.searchTags,
          status: STATUSES.SUCCESS,
          isLoaded: true,
          list: action.payload.result.items,
        },
      };
    case `${t.FETCH_SEARCH_TAGS}_ERROR`:
      return {
        ...state,
        searchTags: {
          ...state.searchTags,
          status: STATUSES.ERROR,
        },
      };

    case `${t.FETCH_RECOMMENDED_TAGS}_PENDING`:
      return {
        ...state,
        popularTags: {
          ...state.popularTags,
          status: STATUSES.PENDING,
        },
      };
    case `${t.FETCH_RECOMMENDED_TAGS}_SUCCESS`:
      return {
        ...state,
        popularTags: {
          ...state.popularTags,
          status: STATUSES.SUCCESS,
          isLoaded: true,
          pagination: convertListToPagination(action.payload.result),
        },
      };
    case `${t.FETCH_RECOMMENDED_TAGS}_ERROR`:
      return {
        ...state,
        popularTags: {
          ...state.popularTags,
          status: STATUSES.ERROR,
        },
      };

    case `${t.FETCH_CATEGORIES}_SUCCESS`:
      return {
        ...state,
        categories: {
          status: STATUSES.SUCCESS,
          isLoaded: true,
          list: action.payload.result,
        },
      };

    case t.RESET:
      return {
        ...state,
        searchTags: makeListState(),
      };

    default:
      return { ...state };
  }
};
export { initialState };



// WEBPACK FOOTER //
// ./src/app/redux/studio/storyCreateEdit/reducer.js